import Advanced from './advanced.js';

export default Advanced;